module.exports = __webpack_public_path__ + "static/img/k16_12.7a64f25.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/k16_12.png
// module id = mBF/
// module chunks = 0